import { Flex } from 'antd';
import { ReactNode } from 'react';
import Logo from '../../logo/logo';
import styles from './form-wrapper.module.scss';

interface FormWrapperProps {
  children: ReactNode;
}

export default function FormWrapper({ children }: FormWrapperProps) {
  return (
    <Flex className={styles.formWrapper} vertical gap={48} align="center">
      <Logo />
      {children}
    </Flex>
  );
}
